// fancyBox
$('[data-fancybox]').fancybox({
    // Options will go here
    buttons : [
        'slideShow',
        'fullScreen',
        'thumbs',
        'close'
    ]
});

$(".emotion__play svg").click(function() {
    if($(this).parent().hasClass("act")) {
        $(this).parent().removeClass("act");
        $('.emotion__video, .emotion__video-overlay').fadeOut(300);
        $('.emotion__video').get(0).pause();
    } else {
        $(this).parent().addClass("act");
        $('.emotion__video, .emotion__video-overlay').fadeIn(300);
        $('.emotion__video').get(0).play();
    }
});

// scroll to the content
$('.emotion__arrows .svg-icon').click(function() {
    var mainContentOffset = $('.maincontent').offset().top;
    $('html, body').animate({scrollTop:mainContentOffset}, 'slow');
    return false;
});


// open / close mobile menu function
var toggleMobileMenu = function(el) {
    el.toggleClass('act');
    if (el.hasClass('act')) {
        $('.main-nav').addClass("act");
    } else {

        $('.main-nav').removeClass("act");
    }
}


// open mobile menu
$('.mobile-nav .mobile-icon').click(function() {
    toggleMobileMenu($(this));
});

var mobileNav = $('.mobile-nav:visible').length;

// generate the navigation depending on mobile nav icon and device (touch or click)
var navGenerator = function() {
    // check if mobile nav is active
    if(mobileNav) {
        // mobile nav
        $('.main-nav__item--lv1 .plus').click(function() {
            $(this).next().slideToggle(300);
            $(this).toggleClass("act");
        });

        // collect navigation objects to place them inside the mobile navigation
        var $serviceNav = $('.service-nav').clone();
        var $contactNav = $('.icon-nav').clone();

        $serviceNav.appendTo(".main-nav");
        $contactNav.appendTo(".footerbottom");

    } else {
        // desktop nav
        if (!("ontouchstart" in document.documentElement)) {
            // hover navigation
            $('.main-nav--lv1 > .main-nav__item--lv1.has-children').on({
                mouseenter: function () {
                    $(".main-nav--lv2", this).fadeIn(200);
                    $(".main-nav__link--lv1", this).addClass("sub-hover");
                },
                mouseleave: function () {
                    $(".main-nav--lv2", this).fadeOut(200);
                    $(".main-nav__link--lv1", this).removeClass("sub-hover");
                }
            });

        } else {
            // touch navigation with click
            document.documentElement.className += " touch";
            $('.main-nav__item--lv1.has-children .main-nav__link--lv1').click(function(event) {
                if(!$(this).hasClass("submenu-open")) {
                    event.preventDefault();
                    $(this).parent().find('.main-nav--lv2').fadeIn(200);
                    $(this).parent().addClass("submenu-open");
                    $(this).parent().find('.main-nav__link--lv1').removeClass("inactive");

                    $(this).parent().siblings().removeClass("submenu-open");
                    $(this).parent().siblings().find('.main-nav__link--lv1').addClass("inactive");
                    $(this).parent().siblings().find('.main-nav--lv2').fadeOut(450);
                } else {
                    event.preventDefault();
                    $(this).parent().find('.main-nav--lv2').fadeOut(450);
                    $(this).parent().find('.main-nav__link--lv1').addClass("inactive");
                    $(this).parent().siblings().find('.main-nav__link--lv1.act').removeClass("inactive");
                    $(this).parent().removeClass("submenu-open");
                }
            });

            // add main navigation link as first child of submenu to make it accessible
            $('.main-nav__item--lv1.has-children').each(function() {
                var $parentElement = $(this);
                var $parentLink = $parentElement.find('.main-nav__link--lv1');
                var $subMenu = $(this).find('.main-nav--lv2');
                // clone parentlink to the submenu
                $parentLink.clone().removeClass("main-nav__link--lv1").addClass('main-nav__link--lv2').prependTo($subMenu).wrap( "<li class='main-nav__item--lv2'></li>" );
            });

            // navi - hide navigation when clicked outside
            $(document).click(function(event) {
                $target = $(event.target);

                if(!$target.closest('.main-nav').length && $('.main-nav--lv2').is(":visible")) {
                    $(".main-nav__item--lv1").removeClass("submenu-open");
                    $(".main-nav__link--lv1.act").removeClass("inactive");
                    $(".main-nav--lv2").fadeOut(450);
                }
            });
        }

    }
};

navGenerator();


// anchor navigation clone – overwritten by initAnchorNavigation()
var updateAnchorNavClone = function() {};

// sticky navigation
$(window).scroll(function(){
    // sticky header - shrinked (only for desktop navigation)
    if($(this).scrollTop() > 100) {
        $('.mainheader__inner').addClass("fixed");
    } else {
        $('.mainheader__inner').removeClass("fixed");
    }

    if($(this).scrollTop() > 460) {
        $('.mainheader__inner').addClass("show");
    } else {
        $('.mainheader__inner').removeClass("show");
    }

    // update fixed anchor navigation clone
    updateAnchorNavClone();
});



// wait for event for resize
var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout (timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

// window width
var windowWidth = $(window).width();

$(window).on('resize', function(){
    waitForFinalEvent(function(){

        // checkif  window width has changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() != windowWidth) {
            // uodate the window width for the next time
            windowWidth = $(window).width();

            // reload the page after resize finished to initialize all functions depending on viewport
            location.reload();
        }
    }, 500, "resize");
});


// business area swiper
const businessareaSwiper = new Swiper('.businessarea__swiper', {
    // Optional parameters
    loop: true,
    autoHeight: true,
    speed: 600,

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // Responsive breakpoints
    breakpoints: {
        320: {
            slidesPerView: 1,

        },
        481: {
            slidesPerView: 2,

        },
        670: {
            slidesPerView: 3,

        },
        1100: {
            slidesPerView: 4,
        },
    }
});


// facts swiper
const factsSwiper = new Swiper('.facts__swiper', {
    // Optional parameters
    loop: true,
    autoHeight: true,
    speed: 600,

    // Navigation arrows
    navigation: {
        nextEl: '.fact__arrow--right',
        prevEl: '.fact__arrow--left',
    },

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<div class="' + "fact__number " + className + '">' + '<div class="fact__number__orig">' + (index + 1) + ".</div>" + "</div>";
        },
    },

    // Responsive breakpoints
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1,
        },
        670: {
            slidesPerView: 2,
        },
        1025: {
            slidesPerView: 3,
        },
    }
});


// testimonial swiper
const testimonialSwiper = new Swiper('.testimonial__swiper', {
    // Optional parameters
    loop: true,
    autoHeight: true,
    speed: 600,

    // Navigation arrows
    navigation: {
        nextEl: '.testimonial__arrow--right',
        prevEl: '.testimonial__arrow--left',
    },

    // Responsive breakpoints
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
    }
});


// check if the device is a touch device or not
if (!("ontouchstart" in document.documentElement)) {
    // infographic on hover
    $('.infographic__info .svg-icon').on({
        mouseenter: function () {
            $(this).next().fadeIn(200);
        },
        mouseleave: function () {
            $(this).next().fadeOut(200);
        }
    });
} else {
    // infographic on click
    $('.infographic__info .svg-icon').click(function() {
        $(this).next().fadeToggle(300);
    });
}


// Script for preselect application in the form

handlePreselectionOfJobSelect();


function handlePreselectionOfJobSelect() {
    // get preselected page uid
    const preselectedOptionId = $('body').attr('data-uid');

    if (!preselectedOptionId) {
        return;
    }
    // get select field
    let $preselectedOption = $(`select option[value=${preselectedOptionId}]`);

    // select option of select
    if ($preselectedOption.length > 0) {
        $preselectedOption.prop('selected', true);
    }

    // update all values of select fields for output in mail
    $('select option').each(function () {
        let $option = $(this);
        $option.attr('value',$option.text());
    })

}

// Home Pop Up
// $(window).load(function () {
$('.popup-close').click(function(){
    $('.popup-overlay').hide();
});
// });


// =========
// Anchor Navigation
// =========
function initAnchorNavigation() {
    var $anchorNav = $('.re4-anchornavigation');
    if (!$anchorNav.length) return;

    var fixedClass   = 're4-anchornavigation--fixed';
    var activeClass  = 're4-anchornavigation__item--active';
    var linkSelector = '.re4-anchornavigation__link';
    var itemSelector = '.re4-anchornavigation__item';

    // --- Collect target sections by reading the hash from each link's href ---
    var sections = [];
    $anchorNav.find(linkSelector).each(function() {
        var href = $(this).attr('href') || '';
        var hashIndex = href.indexOf('#');
        if (hashIndex === -1) return; // no hash → not an anchor link, skip
        var hash = href.substring(hashIndex); // e.g. "#section-leistungen"
        var id   = hash.substring(1);
        var $section = $('#' + id);
        if ($section.length) {
            sections.push({ el: $section[0], hash: hash });
        }
    });

    // --- Set active item on all instances (original + clone) by hash ---
    // Matches via the href attribute so no data-attribute is needed
    var setActiveItem = function(hash) {
        $(itemSelector).removeClass(activeClass);
        $(linkSelector + '[href$="' + hash + '"]').closest(itemSelector).addClass(activeClass);
    };

    // --- IntersectionObserver: activate item when ≥ 5 % of section is visible ---
    if (sections.length && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    setActiveItem('#' + entry.target.id);
                }
            });
        }, { threshold: 0.05 });

        sections.forEach(function(section) {
            observer.observe(section.el);
        });
    }

    // --- Clone management: create / destroy fixed clone below sticky header ---
    var cloneTimer = null;

    updateAnchorNavClone = function() {
        // No clone on mobile (mobile-nav icon visible = mobile viewport)
        if ($('.mobile-nav:visible').length) return;

        var $header        = $('.mainheader__inner');
        var isFixed        = $header.hasClass('fixed') && $header.hasClass('show');
        var $existingClone = $('.' + fixedClass);

        if (isFixed && !$existingClone.length && !cloneTimer) {
            // Wait for the header's CSS transition (500 ms) to finish
            // before inserting the clone, so it appears below the fully
            // slid-in header and not behind / above it.
            cloneTimer = setTimeout(function() {
                cloneTimer = null;

                // Re-check: header might have scrolled away during timeout
                if (!$('.mainheader__inner').hasClass('fixed') ||
                    !$('.mainheader__inner').hasClass('show')) return;

                var headerHeight = $header.outerHeight();
                var $clone = $anchorNav.clone(true)
                    .addClass(fixedClass)
                    .css('top', headerHeight + 'px')
                    .appendTo('body');

                // Apply scroll-margin-top = header + clone height
                var totalOffset = headerHeight + $clone.outerHeight();
                sections.forEach(function(section) {
                    section.el.style.scrollMarginTop = totalOffset + 'px';
                });
            }, 500);

        } else if (!isFixed && $existingClone.length) {
            // Cancel pending creation if header hides before timeout fires
            if (cloneTimer) {
                clearTimeout(cloneTimer);
                cloneTimer = null;
            }
            // Remove clone and reset scroll-margin-top
            $existingClone.remove();
            sections.forEach(function(section) {
                section.el.style.scrollMarginTop = '';
            });
        }
    };

    // Initial call (no-op until header becomes fixed+show)
    updateAnchorNavClone();
}

initAnchorNavigation();


